// logic
import { useHistory } from 'react-router-dom';
// settings
import { createTicketFormSchema } from '../ticketForm/config/ticketFormSchema';
// service
import ticketService from 'modules/emergencies/ticketService';

// returns ticketSettings with loading state
const useNewTicket = () => {
  const history = useHistory();

  const validationSchema = createTicketFormSchema({ isEdit: false });

  const initialValues = ticketService.defaultValues.getDefaultInitialFormValues();

  const isReadOnly = false;

  const isEdit = false;

  const onSubmit = async ({ ticketDto }) => {
    await ticketService.callBackend.createNewTicket({ ticketDto });
    history.push('/emergencies');
  };

  const onCancel = async () => {
    history.push('/emergencies');
  };

  return {
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
  };
};

export default useNewTicket;
